export function promiseSerial(funcs: Array<Function>) {
  return funcs.reduce(
    (promise, func) => promise.then(() => func()),
    Promise.resolve(),
  );
}

export function handleBeforeRedirect(funcs: Array<Function>, timeout: number) {
  if (timeout) {
    return Promise.race([
      new Promise(function(resolve) {
        setTimeout(resolve, timeout, 'handleBeforeRedirect timed out');
      }),
      promiseSerial(funcs),
    ]);
  } else {
    return promiseSerial(funcs);
  }
}
